import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
    namespaced: true,
    state: {
        step: 1,
        requestData: {
            name: undefined,
            organizationName: undefined,
            cnpj: undefined,
            countryId: undefined,
            postcode: undefined,
            addressLine1: undefined,
            number: undefined,
            addressLine2: undefined,
            neighbourhood: undefined,
            stateId: undefined,
            cityId: undefined,
            nationality: undefined,
            cpf: undefined,
            passport: undefined,
            gender: undefined,
            birthDate: undefined,
            mother_name: undefined,
            title: undefined,
            email: undefined,
            mobile: undefined,
            password: undefined,
            signedDocumentId: undefined,
        }
    },
    mutations,
    actions,
    getters
}
